module.exports = __webpack_public_path__ + "media/images/flat_rate_camp_banner_sp-d8c9287f4cf4a3614fae48770cae63e2.png";